import React, { useEffect, useState } from 'react';

import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
  TablePagination,
} from '@mui/material';

import { Edit as EditIcon } from '@mui/icons-material';

import { processingAPI } from '../Api';

const ProcGroups2 = () => {
  const [procGroups, setProcGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editDialog, setEditDialog] = useState({ open: false, item: null, value: '' });
  const [alert, setAlert] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await processingAPI.getProcGroups();
      setProcGroups(res.data?.data || []);
    } catch (error) {
      console.error('Error loading ProcGroups:', error);
      setAlert(<Alert severity="error">Ошибка загрузки данных</Alert>);
    } finally {
      setLoading(false);
    }
  };

  const handleEditCommission = (item) => {
    setEditDialog({ open: true, item, value: item.comissiom ?? 0 });
  };

  const handleSaveCommission = async () => {
    const { item, value } = editDialog;
    if (!item) return;

    const numValue = Number(value);
    if (isNaN(numValue)) {
      setAlert(<Alert severity="error">Некорректное значение комиссии</Alert>);
      return;
    }

    try {
      await processingAPI.updateProcGroup(item._id, { comissiom: numValue });
      setEditDialog({ open: false, item: null, value: '' });
      setAlert(<Alert severity="success">Комиссия обновлена</Alert>);
      loadData();
    } catch (error) {
      console.error('Error updating commission:', error);
      setAlert(<Alert severity="error">Ошибка обновления комиссии</Alert>);
    }
  };

  const formatDate = (date) => {
    if (!date) return '—';
    return new Date(date).toLocaleString('ru-RU');
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" mb={3}>
        Группы процессингов 2
      </Typography>

      {alert && <Box mb={2}>{alert}</Box>}

      <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', borderBottom: '2px solid #ddd' }}>procId</TableCell>
              <TableCell sx={{ fontWeight: 'bold', borderBottom: '2px solid #ddd' }}>Платформы</TableCell>
              <TableCell sx={{ fontWeight: 'bold', borderBottom: '2px solid #ddd' }}>Комиссия</TableCell>
              <TableCell sx={{ fontWeight: 'bold', borderBottom: '2px solid #ddd' }}>Создан</TableCell>
              <TableCell sx={{ fontWeight: 'bold', borderBottom: '2px solid #ddd' }}>Обновлён</TableCell>
              <TableCell sx={{ fontWeight: 'bold', borderBottom: '2px solid #ddd' }}>Действия</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {procGroups.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                  Нет данных
                </TableCell>
              </TableRow>
            ) : (
              procGroups
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((pg) => (
                  <TableRow
                    key={pg._id}
                    hover
                    sx={{
                      '&:last-child td': { borderBottom: '1px solid #ddd' },
                      '& td': { borderBottom: '1px solid #ddd' },
                    }}
                  >
                    <TableCell>
                      <code>{pg.procId || '—'}</code>
                    </TableCell>
                    <TableCell>
                      {pg.platforms && pg.platforms.length > 0 ? (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {pg.platforms.map((platform, idx) => (
                            <Chip key={idx} label={platform} size="small" variant="outlined" />
                          ))}
                        </Box>
                      ) : (
                        '—'
                      )}
                    </TableCell>
                    <TableCell>
                      <Typography fontWeight="medium">
                        {pg.comissiom != null ? `${Number(pg.comissiom)}%` : '0%'}
                      </Typography>
                    </TableCell>
                    <TableCell>{formatDate(pg.createdAt)}</TableCell>
                    <TableCell>{formatDate(pg.updatedAt)}</TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => handleEditCommission(pg)}
                        color="primary"
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={procGroups.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Строк на странице:"
        />
      </TableContainer>

      <Dialog open={editDialog.open} onClose={() => setEditDialog({ open: false, item: null, value: '' })}>
        <DialogTitle>Изменить комиссию</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Комиссия (%)"
            type="number"
            fullWidth
            variant="outlined"
            value={editDialog.value}
            onChange={(e) => setEditDialog({ ...editDialog, value: e.target.value })}
            inputProps={{ step: 0.1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditDialog({ open: false, item: null, value: '' })}>Отмена</Button>
          <Button onClick={handleSaveCommission} variant="contained">Сохранить</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ProcGroups2;
